module.exports = __webpack_public_path__ + "static/media/LeftBridgeFemale.af1e6fda.svg";